import { FechaFunctionsService } from '@/utils/functions.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-clientes-deudores',
  templateUrl: './clientes-deudores.component.html',
  styleUrls: ['./clientes-deudores.component.scss']
})
export class ClientesDeudoresComponent {
  clientes: Array<any>;
  deuda: Array<any>;
  searchForm: FormGroup;
  itemsPerPage: number = 10;
  page: number = 1;
  isLoading: boolean = false;
  isExpanded = {};

  constructor(private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    private loadingService: LoadingService,
    public Func: FechaFunctionsService
  ) { }

  async ngOnInit() {
    this.searchForm = this.fb.group({
        search: []
    });  
    await this.getData();
  }

  async getData() {
    try {
      this.loadingService.setLoading(true)
      let res = await this.generalService.getListar("cliente/deudores")
      this.clientes = res.data;
      this.loadingService.setLoading(false)
    } catch (error) {
      this.toastr.error('Error al cargar clientes!')
      this.loadingService.setLoading(false)
    }
  }

  async getDataDeuda(id) {
    try {
      this.isLoading = true
      let res = await this.generalService.getObtiene("pedido/cliente", id, "deuda")
      this.deuda = res.data;
      this.isLoading = false
    } catch (error) {
      this.toastr.error('Error al cargar clientes!')
      this.isLoading = false
    }
  }

  pageChanged(event) {
    this.itemsPerPage = event.itemsPerPage
    this.page = event.page
  }

  goDetalleCliente(idCliente) {
    this.loadingService.setLoading(true);
    localStorage.setItem('idCliente', idCliente);
    this.router.navigate(['/cliente']);
  }

  openDetail(rowIndex, id_cliente) {
    this.clientes.forEach((e, i) => {
      if (i != rowIndex) {
        this.isExpanded[i] = false
      }
    })
    this.getDataDeuda(id_cliente)
    this.isExpanded[rowIndex] = !this.isExpanded[rowIndex]
  }

  async getDataDeudaUpdate(e) {
    this.loadingService.setLoading(true);
    await this.getData();
    let existe = this.clientes.find(function (objeto) {
      return objeto.id_cliente === e;
    });
    if (existe) {
      this.getDataDeuda(e)
      this.loadingService.setLoading(false);
    }
    else {
      this.clientes.forEach((e, i) => {
          this.isExpanded[i] = false
      })
      this.loadingService.setLoading(false);
    }
  }
}
